import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20illustration%20with%20dramatic%20composition%2C%20warm%20orange%20and%20coral%20gradient%20background%2C%20stylized%20comic%20panel%20aesthetic%2C%20clean%20modern%20japanese%20korean%20manga%20art%20style%2C%20soft%20atmosphere%20with%20cinematic%20lighting%2C%20minimal%20design%2C%20abstract%20artistic%2C%20high%20resolution%2C%20editorial%20quality&width=1600&height=900&seq=hero-01&orientation=landscape"
        alt="韩漫漫画 - 免费韩国漫画下拉式在线观看"
        title="韩漫漫画网站 - 韩漫在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 md:mb-6 leading-tight">
            免费韩国漫画
          </h1>
          <p className="text-xl md:text-2xl lg:text-3xl font-heading font-medium text-background-50/90 mb-6 md:mb-8">
            下拉式在线观看
          </p>
          <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
            海量高清韩国漫画资源，每日极速更新，下拉式流畅阅读体验，随时随地沉浸在精彩漫画世界中。
          </p>
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-8 py-3 md:px-10 md:py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            立即开始阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        <div className="w-8 h-1 rounded-full bg-primary-500"></div>
        <div className="w-2 h-1 rounded-full bg-background-50/40"></div>
        <div className="w-2 h-1 rounded-full bg-background-50/40"></div>
      </div>
    </section>
  );
}